import { AuthPort } from './ports/AuthPort';
import { IdentityRepository } from './ports/IdentityRepository';
import { ManagerRepository } from './ports/ManagerRepository';
 
import { 
  LoginUseCase, 
  GetSessionUseCase, 
  ChangePasswordUseCase, 
  RequestPasswordResetUseCase, 
  ResetPasswordUseCase, 
  InviteStaffUseCase 
} from './usecases';

export class IdentityDomainFactory {
  private loginUseCase?: LoginUseCase;
  private getSessionUseCase?: GetSessionUseCase;
  private changePasswordUseCase?: ChangePasswordUseCase;
  private requestPasswordResetUseCase?: RequestPasswordResetUseCase;
  private resetPasswordUseCase?: ResetPasswordUseCase;
  private inviteStaffUseCase?: InviteStaffUseCase;

  constructor(
    public readonly authPort: AuthPort,
    private readonly identityRepo: IdentityRepository,
    private readonly managerRepo: ManagerRepository
  ) {}

  getRepository(): IdentityRepository {
    return this.identityRepo;
  }

  getManagerRepository(): ManagerRepository {
    return this.managerRepo;
  }

  getLoginUseCase(): LoginUseCase {
    if (!this.loginUseCase) {
      this.loginUseCase = new LoginUseCase(this.authPort, this.identityRepo);
    }
    return this.loginUseCase;
  }

  getGetSessionUseCase(): GetSessionUseCase {
    if (!this.getSessionUseCase) {
      this.getSessionUseCase = new GetSessionUseCase(this.identityRepo);
    }
    return this.getSessionUseCase;
  }

  getChangePasswordUseCase(): ChangePasswordUseCase {
    if (!this.changePasswordUseCase) {
      this.changePasswordUseCase = new ChangePasswordUseCase(this.authPort, this.identityRepo);
    }
    return this.changePasswordUseCase;
  }

  getRequestPasswordResetUseCase(): RequestPasswordResetUseCase {
    if (!this.requestPasswordResetUseCase) {
      this.requestPasswordResetUseCase = new RequestPasswordResetUseCase(this.authPort);
    }
    return this.requestPasswordResetUseCase;
  }

  getResetPasswordUseCase(): ResetPasswordUseCase {
    if (!this.resetPasswordUseCase) {
      this.resetPasswordUseCase = new ResetPasswordUseCase(this.authPort);
    }
    return this.resetPasswordUseCase;
  }

  getInviteStaffUseCase(): InviteStaffUseCase {
    if (!this.inviteStaffUseCase) {
      this.inviteStaffUseCase = new InviteStaffUseCase(this.authPort, this.identityRepo);
    }
    return this.inviteStaffUseCase;
  }
}

// Singleton instance will be initialized in the app entry point with concrete infrastructure
export let identityDomain: IdentityDomainFactory;

export const initializeIdentityDomain = (
  authPort: AuthPort, 
  identityRepo: IdentityRepository,
  managerRepo: ManagerRepository
) => {
  identityDomain = new IdentityDomainFactory(authPort, identityRepo, managerRepo);
};
